import React from "react";
import formatCurrency from "../../formatters/currency";

const StepResumen = ({ formData, planesSeleccionados, planes }) => {
  const comunaNombre = formData.comuna || "-";

  const planesElegidos = planes.filter((p) =>
    planesSeleccionados.includes(p._id)
  );

  return (
    <div className="space-y-6">
      <div className="bg-white shadow rounded-xl p-4">
        <h3 className="text-lg font-semibold mb-2 text-gray-800">Datos Personales</h3>
        <ul className="text-sm text-gray-700 space-y-1">
          <li><strong>RUT:</strong> {formData.rut}</li>
          <li><strong>Nombre:</strong> {formData.nombre}</li>
          <li><strong>Email:</strong> {formData.email}</li>
          <li><strong>Teléfono:</strong> {formData.telefono}</li>
          <li><strong>Dirección:</strong> {formData.direccion}</li>
          <li><strong>Número:</strong> {formData.numero}</li>
          <li><strong>Comuna:</strong> {formData.nombreComuna}</li>
        </ul>
      </div>

      <div className="bg-white shadow rounded-xl p-4">
        <h3 className="text-lg font-semibold mb-2 text-gray-800">Planes Seleccionados</h3>
        {planesElegidos.length === 0 ? (
          <p className="text-gray-500 text-sm">No se ha seleccionado ningún plan.</p>
        ) : (
          <ul className="text-sm text-gray-700 space-y-2">
            {planesElegidos.map((plan) => (
              <li key={plan.id} className="flex justify-between">
                <div className="flex-grow">
                  <p className="font-medium">{plan.nombrePlan}</p>
                  <p className="text-xs text-gray-500">{plan.descripcion}</p>
                </div>
                <div className="text-right text-sm text-indigo-600 font-bold whitespace-nowrap">
                  {formatCurrency(plan.valor)}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default StepResumen;
